var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"50%","before-close":_vm.close},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('QuickNote',{attrs:{"customerId":_vm.customerId,"contactId":_vm.contactId,"note":_vm.note,"noteId":_vm.noteIdToEdit},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }